import React, { useEffect } from "react";
import { auth } from "../firebase";

export default function Success() {
  useEffect(() => {
    const refreshToken = async () => {
      if (auth.currentUser) {
        // 🔄 Force refresh so Pro claim is available immediately
        await auth.currentUser.getIdToken(true);
      }
    };

    refreshToken();
  }, []);

  return (
    <div className="center-screen">
      <div className="glass-card">
        <h2>✅ Subscription Successful</h2>

        <p>Pro features are now unlocked.</p>

        <a href="/app" className="primary-btn">
          Go to app
        </a>
      </div>
    </div>
  );
}
